<mat-form-field>
  <mat-select placeholder="Module" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let module of dmsModules" [value]="module">
      {{ module }}
    </mat-option>
  </mat-select>
</mat-form-field>
